import React, { Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom'

import { AppProvider } from '../providers/AppContext.tsx';
import ScrollToTop from '../components/layout/ScrollToTop.tsx';

import { ToastProvider } from '../hooks/useToast.tsx';
const AppRouter = React.lazy(() => import('./AppRouter.tsx'));
const PublicRouter2 = React.lazy(() => import('./PublicRouter2.tsx'));

const RouterProvider = () => {
  return (
    <BrowserRouter basename={import.meta.env.BASE_URL}>
      <ScrollToTop />
        <AppProvider>
          <ToastProvider>
            <Suspense fallback={<div className="loading-screen">Cargando...</div>}>
              <Routes>
                <Route path="/*" element={<PublicRouter2 />} />
                <Route path="/app/*" element={<AppRouter />} />
              </Routes>
            </Suspense>
          </ToastProvider>
        </AppProvider>
    </BrowserRouter>
  )
}

export default RouterProvider
